import {cx} from "emotion";
import * as React from "react";

import "./div-collapser-2.scss";

import {cs} from "@Common/react/chain-services";

import {DivCollapser} from "../div-collapser/div-collapser";

export const DivCollapser2 = ({next, expandedBottomPadding=undefined, collapsedHeight}) => cs(
    ["divCollapser", (_, next) => DivCollapser({
        collapsedHeight,
        expandedBottomPadding,
        next,
    })],
    ({divCollapser}) => next({
        ...divCollapser,
        render: ({className, renderContent}) => (
            <div
                className={cx(
                    "div-collapser-2-0dd",
                    className,
                    divCollapser.state,
                )}
                ref={divCollapser.outerRef}
                style={{
                    ...!divCollapser.expanded && {
                        height: divCollapser.outerHeight,
                    }
                }}
            >
                {renderContent(divCollapser.innerRef)}
            </div>
        ),
    }),
);
